import { create } from 'zustand';

export interface QueueEntry {
  id: string;
  label: string;
}

interface QueueState {
  queue: QueueEntry[];
  isLive: boolean;
  setQueue: (queue: QueueEntry[]) => void;
  addEntry: (entry: QueueEntry) => void;
  setLive: (live: boolean) => void;
  reset: () => void;
}

export const useQueueStore = create<QueueState>((set) => ({
  queue: [],
  isLive: false,
  setQueue: (queue) => set({ queue }),
  addEntry: (entry) => set((s) => ({ queue: [...s.queue, entry] })),
  setLive: (live) => set({ isLive: live }),
  reset: () => set({ queue: [], isLive: false }),
}));
